export default __webpack_public_path__ + "static/media/banana.2a28eed8.png";